import type { JSX } from "react";
import type { ExportChartFormats } from "../../viewer/chart/ChartProps.ts";
import ExportButton from "./ExportButton.tsx";
import { exportFormats } from "./exportOptions.tsx";

interface Props {
  reportName?: string;
  warning?: string;
  onExport: (fileName: string, format: ExportChartFormats) => void;
}

const ChartReportExport = ({ reportName, warning, onExport }: Props): JSX.Element => (
  <ExportButton
    warning={warning}
    options={exportFormats.map(({ ext, icon }) => ({
      key: ext,
      title: ext,
      Icon: icon,
      onClick: () => onExport(reportName || "Exported Chart", ext),
    }))}
  />
);

export default ChartReportExport;
